module.exports = __webpack_public_path__ + "img/al.d929e85e.png";